import dayjs from 'dayjs';
import 'dayjs/locale/sr';
import 'dayjs/locale/sq';
import 'dayjs/locale/fr';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.extend(updateLocale);
dayjs.updateLocale('en', {
  weekStart: 1,
});
export const localizeDayjs = (lng: string) => dayjs.locale(lng);
